<div class="flex justify-between">
  <div class="flex-direction-column justify-center">
    <span class="font-mobile color-primary">Canal</span>
    <span class="font-mobile">{{ sessao?.canal?.nome ?? '--' }}</span>
  </div>
  <div class="flex-direction-column justify-center">
    <span class="font-mobile color-primary">Data Abertura</span>
    <span class="font-mobile">{{ (sessao!.dataInicio | date:'dd/MM/yyyy - HH:mm') ?? '--' }}</span>
  </div>
  <div class="flex-direction-column justify-center">
    <span class="font-mobile color-primary">Última Interação</span>
    <span class="font-mobile">{{ (sessao!.dataUltimaMensagem | date:'dd/MM/yyyy - HH:mm') ?? '--' }}</span>
  </div>
  <div>
    @if (sessao && sessao.operadorUuid && sessao.operadorExtensaoImg){
      <img [src]="gerarUrl(sessao.operadorUuid, sessao.operadorExtensaoImg, 'usuario-img')" class="modal-lateral-imagem" style="width: 25px; height: 25px; cursor: unset;" alt="Foto do operador" />
    }
    @else {
      <img src="./assets/icones/box-happy.png" alt="">
    }
  </div>
</div>
